"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDeprecatedRules = convertDeprecatedRules;
exports.splitDeprecatedRuleProblems = splitDeprecatedRuleProblems;
const reviews_1 = require("../../reviews");
const common_1 = require("./common");
function convertDeprecatedRules(nodes, pcbLayoutRuleSets) {
    return (problem) => {
        const designatorUidMap = {};
        const designator = problem.affectedItems
            .filter(({ type }) => type !== "ruleSet")
            .map((a) => {
            const designator = (0, common_1.sanitizeDesignator)(a.itemLabel ?? (0, common_1.getLabelForPcbNode)(nodes[a.uid]));
            designatorUidMap[designator] = a.uid;
            return designator;
        })
            .join(", ");
        const rule = problem.affectedItems
            .filter(({ type }) => type === "ruleSet")
            .map((a) => {
            const designator = (0, common_1.sanitizeDesignator)((0, common_1.getLabelForRuleSet)(a.uid, pcbLayoutRuleSets));
            if (designator) {
                designatorUidMap[designator] = a.uid;
            }
            return designator;
        })
            .join(", ");
        return {
            name: designator ?? null,
            designator,
            rule,
            status: reviews_1.ReviewStatus.WARNING,
            designatorUidMap,
        };
    };
}
function splitDeprecatedRuleProblems(problems) {
    const deprecatedRuleProblems = problems.filter((problem) => problem.problemTypeKey === "deprecated_rules");
    return deprecatedRuleProblems.flatMap((problem) => {
        const ruleSets = problem.affectedItems.filter((item) => item.type === "ruleSet");
        const nodes = problem.affectedItems.filter((item) => item.type === "pcbLayoutNode");
        return nodes.map((node) => ({ ...problem, affectedItems: [node, ...ruleSets] }));
    });
}
//# sourceMappingURL=deprecatedRules.js.map